import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Icon from 'components/Icon';
import LangSwitcher from 'components/LangSwitcher';
import Divider from 'components/Divider';
import { useSelector, useDispatch } from 'react-redux';
import * as authActions from 'store/modules/auth';
import * as walletActions from 'store/modules/wallet';
import * as appActions from 'store/modules/app';
import './Drawer.scss';

const Drawer = withRouter(injectIntl(({ location, intl, ...props }) => {
  const isDrawerOpen = useSelector(state => state.app.isDrawerOpen);
  const dispatch = useDispatch();
  const toggleDrawer = () => dispatch(appActions.toggleDrawer());
  const setMyAssets = assets => dispatch(walletActions.setMyAssets(assets));
  const branchInfo = useSelector(state => state.branch);
  const logout = () => {
    if (
      window.confirm(intl.formatMessage({ id: 'alert.do_you_want_to_log_out' }))
    ) {
      dispatch(authActions.logout());
      setMyAssets([]);
    }
  };
  const { isAuthenticated, memberinfo } = useSelector(state => state.auth);
  const changeLanguage = lang => {
    localStorage.setItem('lang', lang);
    window.location.reload();
  };

  return (
    <>
      <div
        class={['drawer-backdrop', isDrawerOpen ? 'drawer-open' : ''].join(' ')}
        onClick={toggleDrawer}
      ></div>
      <div class={['drawer', isDrawerOpen ? 'drawer-open' : ''].join(' ')}>
        <div class="drawer-inner">
          <div class="drawer-top">
            <div className="drawer-top-btn-wrap">
              <div class="btn-group">
                <button onClick={toggleDrawer}>
                  <Icon name="close" />
                </button>
              </div>
              <div class="btn-group">
                <button>
                  <Link onClick={toggleDrawer} to="/">
                    <Icon name="home" />
                  </Link>
                </button>
                {isAuthenticated ? (
                  <button onClick={logout}>
                    <Icon name="logout" />
                  </button>
                ) : (
                  <button>
                    <Link onClick={toggleDrawer} to={{
                      pathname: "/account/login",
                      state: { from: location },
                    }}>
                      <Icon name="login" />
                    </Link>
                  </button>
                )}
              </div>
            </div>
            <div className="drawer-login-info">
              {isAuthenticated ? (
                <>
                  <p>
                    <span class="userid">{memberinfo ? memberinfo.mb_name : ''}</span>{' '}
                    <FormattedMessage id="main.is_logged_in" />
                  </p>
                  <Divider color="#60697a" />
                  <ul>
                    <li>
                      <FormattedMessage id="mypage.security_level" />
                    </li>
                    <li>
                      {memberinfo ? memberinfo.mb_level : ''}
                      <FormattedMessage id="mypage.level" />
                    </li>
                  </ul>
                </>
              ) : (
                <p>
                  <Link onClick={toggleDrawer} to={{
                      pathname: "/account/login",
                      state: { from: location },
                    }}>
                    <FormattedHTMLMessage id="common.please_login" />
                  </Link>
                </p>
              )}
            </div>
          </div>
          <div className="drawer-menu-wrap">
            <div className="language-selector">
              <LangSwitcher
                selected={'-'}
                onChange={v => {
                  changeLanguage(v);
                }}
              />
            </div>
            {branchInfo.partnerInfo.pm_state !== 'JOIN' ? <ul className="drawer-menu">
              <Link onClick={toggleDrawer} to="/trade">
                <li className="drawer-menu-item">
                  <FormattedMessage id="menu.exchange" />
                </li>
              </Link>
              <Link onClick={toggleDrawer} to="/myinvest">
                <li className="drawer-menu-item">
                  <FormattedMessage id="menu.myinvest" />
                </li>
              </Link>
              <Link onClick={toggleDrawer} to="/wallet">
                <li className="drawer-menu-item">
                  <FormattedMessage id="menu.wallet" />
                </li>
              </Link>
              <Link onClick={toggleDrawer} to="/mypage">
                <li className="drawer-menu-item">
                  <FormattedMessage id="menu.mypage" />
                </li>
              </Link>
              <Link onClick={toggleDrawer} to="/swap/coin">
                <li className="drawer-menu-item">
                  스왑
                </li>
              </Link>
              <Link onClick={toggleDrawer} to="/cscenter">
                <li className="drawer-menu-item">
                  <FormattedMessage id="menu.cscenter" />
                </li>
              </Link>
              {(branchInfo.linkData ? branchInfo.linkData : []).map(n => n.is_use === 'true' && n.url !== '' ?
                <a href={n.url} target={n.target}><li class="drawer-menu-item"><span>{n.menu}</span></li></a>
              : null)}
            </ul> : <ul className="drawer-menu">
              <Link onClick={toggleDrawer} to="/cscenter">
                <li className="drawer-menu-item">
                  <FormattedMessage id="menu.cscenter" />
                </li>
              </Link>
            </ul>}
          </div>
        </div>
      </div>
    </>
  );
}));

export default Drawer;
